import React from 'react';

import { useEffect, useRef } from 'react';

import { useNavigate, Form } from 'react-router-dom';

import { Container } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';

import { FormGroup } from 'react-bootstrap';
import { FormLabel } from 'react-bootstrap';
import { FormControl } from 'react-bootstrap';
import { Button } from 'react-bootstrap';

import { Editor } from '@tinymce/tinymce-react';

import FAQStore from '../../../stores/FAQStore';

const FAQItemCreatePage = ({ users }) => {
    const navigate = useNavigate();

    const store = FAQStore((state) => state);

    const editorRef = useRef(null);

    useEffect(() => {
        store.resetFaqItem();
        // The [] is for specifying dependencies, and for componentDidMount lifecycle equivalent
        // we need to specify no dependencies.
        // See https://stackoverflow.com/questions/53945763/componentdidmount-equivalent-on-a-react-function-hooks-component
    }, []);

    return (
        <Container style={{ marginTop: '10px', width: '100%' }}>
            <Row className="show-Container">
                <Col xs={12} md={8}>
                    <Button
                        onClick={() => {
                            navigate('/faqItem');
                        }}
                    >
                        Back to list
                    </Button>

                    <div>FAQItem Creation Page</div>

                    <br />

                    <Form method="post">
                        <FormGroup>
                            <FormLabel>
                                Title<span className="text-danger">*</span>
                            </FormLabel>
                            <FormControl
                                name="firstName"
                                type="text"
                                onChange={(e) => {
                                    store.updateAttribute(
                                        'title',
                                        e.target.value,
                                    );
                                }}
                            />
                        </FormGroup>

                        <FormGroup key={'form-position'} controlId={'position'}>
                            <FormLabel>
                                Position<span className="text-danger">*</span>
                            </FormLabel>

                            <FormControl
                                type="text"
                                onChange={(e) => {
                                    store.updateAttribute(
                                        'position',
                                        e.target.value,
                                    );
                                }}
                            />
                        </FormGroup>

                        <Editor
                            onInit={(evt, editor) =>
                                (editorRef.current = editor)
                            }
                            init={{
                                height: 500,
                                menubar: false,
                                plugins: ['code', 'media'],
                                toolbar:
                                    'undo redo | formatselect | ' +
                                    'bold italic backcolor | alignleft aligncenter ' +
                                    'alignright alignjustify | bullist numlist outdent indent | ' +
                                    'removeformat | help | code | media ',
                                content_style:
                                    'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                            }}
                            onEditorChange={(content) => {
                                store.updateAttribute('htmlContent', content);
                            }}
                        />

                        <br />
                        <br />

                        <Button
                            onClick={() => {
                                store.create(
                                    store.faqItem,
                                    () => {
                                        alert('Your faqItem was saved');
                                        navigate('/faqItem');
                                    },
                                    () => {
                                        alert('Something went wrong!');
                                    },
                                );
                            }}
                        >
                            Create
                        </Button>

                        <Button
                            style={{ marginLeft: '5px' }}
                            onClick={() => {
                                navigate('/faqItem');
                            }}
                        >
                            Cancel
                        </Button>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
};

export default FAQItemCreatePage;
